import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, ShieldAlert } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PageSEO from "@/components/PageSEO";

const VerifyAdminPassword = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("Vérification de sécurité en cours...");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("error");
      setMessage("Lien de vérification invalide.");
      return;
    }

    supabase.functions
      .invoke("verify-admin-password-change", { body: { token } })
      .then(({ error }) => {
        if (error) {
          setStatus("error");
          setMessage("Ce lien est invalide, expiré ou déjà utilisé.");
          return;
        }

        setStatus("success");
        setMessage("Votre mot de passe administrateur a été changé avec succès.");
      });
  }, [searchParams]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <PageSEO
        title="Vérification de sécurité — Maroc Transfers"
        description="Confirmez le changement de mot de passe administrateur de Maroc Transfers via le lien de vérification sécurisé."
        path="/verify-admin-password"
        noindex
      />
      <Card className="w-full max-w-md border-border text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            {status === "loading" && <Loader2 className="h-6 w-6 animate-spin text-primary" />}
            {status === "success" && <CheckCircle2 className="h-6 w-6 text-primary" />}
            {status === "error" && <ShieldAlert className="h-6 w-6 text-destructive" />}
          </div>
          <CardTitle className="font-heading text-2xl">Vérification de sécurité</CardTitle>
        </CardHeader>
        <CardContent className="space-y-5">
          <p className="font-body text-sm leading-relaxed text-muted-foreground">{message}</p>
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/adminup">Retour à Adminup</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
};

export default VerifyAdminPassword;
